<template>
    <div class="landMonitor">
		<leftnav class="fl" mkcode="B" :itemcode="yj_itemcode"></leftnav>
		<div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
			<govheader></govheader>
			<div class="index_left_centerpage">
                <div class="whitebox right_topbox">
					<div class="right_boxtitle map_title_tab">
						<span class="title" :class="{'current':navValue == list.value}" @click="navValue = list.value;ajaxsearchcompany(1)" v-for="(list) in navList" :key="list.value">{{list.label}}</span>
					</div>
					<monitorComponent class="mt-3"  :type="navValue" v-show="navValue != 4" @search="searchList"></monitorComponent>



				</div>
				<div class="whitebox">
                    <div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl">为您找到<span class="searchnum">{{ total }}</span>条相关结果</p>
					</div>
					<div class="py-3">
                        <table border="0" cellspacing="0" cellpadding="0" class="land_table">
							<tr>
								<th>序号</th>
                                <th>行政区</th>
								<th>项目名称</th>
								<th>筛选条件</th>
                                <th>总面积(亩)</th>
                                <th>土地用途</th>
                                <th>土地使用权人（项目公司）</th>
								<!-- <th>投资主体</th> -->
                                <th >签订日期</th>
                                <th >操作</th>
							</tr>
                            <tr v-for="(item,index) in enterpristlist" :key="item.stockcode">
                                <td>{{(page-1)*pageSize+index+1}}</td>
                                <td>{{item.area}}</td>
                                <td v-show="navValue!= 4" class="title" @click="handlerLinkLocal('/landDetail?id='+item.id+'&pageType=2')">{{item.projectName}}</td>
                                <td v-show="navValue == 4" class="title" @click="handlerLinkLocal('/landDetail?id='+item.id+'&pageType=3')">{{item.projectName}}</td>
                                <td style="width: 120px;"> <el-rate v-model="item.star" :colors="['#333','#333','#333']" :disabled="true" ></el-rate></td>
                                <td>{{item.size.toFixed(2)}}</td>
                                
                                <td>{{item.purpose}}</td>
                                <td :class="item.stockcode ? 'title' : ''" @click="item.stockcode ? routerlinkid('/enterprises?id='+item.stockcode) : ''">{{item.owner}}</td>
                                <!-- <td class="title" @click="routerlinkid('/enterprises?id='+item.stockcode)">{{item.investor || '-'}}</td> -->
                                <td style="width: 100px;">{{item.time ||'-'}}</td>
                                <td v-if="item.pushStatus == 0" class="collectfont1" :class="item.thread?'redfont':''" style="width: 100px;">
                                    <span @click="landThreadToggle(item,'land')">{{item.thread == 0 ? '加入' : '移除'}}线索管理</span>
                                </td>
                                <td v-else style="width: 100px;">已推送</td>
                            </tr>
                    </table>
					</div>
					<div class="centerpage1 company_pagelist" v-show="totalPage > 1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
							v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"></zpagenav>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>
<script> 
import { mapState, mapMutations, mapGetters } from "vuex";
import monitorComponent from "./inc/monitor.vue";
export default {
    name: 'landMonitor',
    components: {
        monitorComponent,
    },
    computed: {
		...mapState({
			// isCollapse: (state) => state.app.isCollapse,
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
    data() {
        return {
            userdata: {},
            page: 1,
            haspage: true,
            pageSize: 20,
            total: 0,
            totalPage: 1,
            maxPage: 10,
            yj_itemcode: "A01",
            navList: [{value: 1, label: '全面监测'},{value: 2, label: '重点行业监测'},{value: 3, label: '重点企业类型监测'},{value: 4, label: '监测线索管理'}],
            navValue: 1,
            enterpristlist: [],
        };
    },
    mounted() {
        this.ajaxsearchcompany();
    },
    methods: {
        searchList(filterData){
            //处理一下filterData里面为‘’和0的数据
            for(let key in filterData){
                if(filterData[key] == '' || filterData[key] == 0){
                    delete filterData[key];
                }
            }
            this.searchData = filterData;
            console.log('this.searchData',this.searchData);
            this.ajaxsearchcompany(1);
        },

         ajaxsearchcompany(pages) {
            this.page = pages ? pages : 1;
            this.bus.$emit('loading', true);
            let params = {
                page: this.page,
                pageSize: this.pageSize,
                thread:this.navValue == 4 ? '1' : '0',
                type:this.navValue == 4 ? '' : this.navValue,
                ...this.searchData
            };
           this.$axios.get(this.$api.metall.Land.MonitorList(), { params: params }).then((res) => {
               if (res.data.success) { 
                this.enterpristlist = res.data.list;
                this.totalPage = res.data.totalPage;
                this.total = res.data.totalRecord;
                this.pageSize = res.data.pageSize;
                this.bus.$emit('loading', false);
               } else {
                //    this.$message.error(res.data.message); 
                this.bus.$emit('loading', false);
               }
           })
        },
        delClue(item) {
            console.log('移除线索管理', item);
        },
        pageHandler(page) {
            this.page = page;
            this.ajaxsearchcompany(page);
        },
    },
};
</script>
<style>
.clueManagement .whitebox{
    min-height: 95vh;
}
</style>